import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  es: {
    translation: {
      app: {
        name: "Modolo Multiservices S.L.",
        tagline: "Panel de control",
      },
      nav: {
        dashboard: "Inicio",
        horas: "Horas",
        reportes: "Informes",
        agenda: "Agenda",
        fotos: "Fotos",
        clientes: "Clientes",
        aprobaciones: "Aprobaciones",
        funcionarios: "Empleados",
        presupuestos: "Presupuestos",
        facturas: "Facturas",
        cierres: "Cierres",
        archivo: "Archivo",
        gastos: "Gastos",
        ingresos: "Ingresos",
        logout: "Cerrar sesión",
      },
      login: {
        title: "Iniciar sesión",
        subtitle: "Accede al panel de Modolo Multiservices S.L.",
        email: "Correo electrónico",
        password: "Contraseña",
        submit: "Entrar",
        loading: "Entrando...",
        error: "Credenciales inválidas",
      },
      dashboard: {
        welcome: "Bienvenido",
        employees: "Empleados",
        clients: "Clientes",
        pendingHours: "Horas pendientes",
        todayAgenda: "Agenda de hoy",
        photos: "Fotos",
        approvedHours: "Horas aprobadas",
        totalHours: "Total de horas",
        myPending: "Mis horas pendientes",
        myApproved: "Mis horas aprobadas",
        myAgenda: "Mi agenda hoy",
        myPhotos: "Mis fotos",
      },
      horas: {
        title: "Registro de horas",
        subtitle: "Añade las horas trabajadas al final del día",
        add: "Añadir horas",
        date: "Fecha",
        start: "Inicio",
        end: "Fin",
        total: "Total",
        client: "Cliente",
        notes: "Observaciones",
        status: "Estado",
        actions: "Acciones",
        employee: "Empleado",
        save: "Guardar",
        cancel: "Cancelar",
        pending: "Pendiente",
        approved: "Aprobado",
        rejected: "Rechazado",
        empty: "No hay registros de horas",
        selectClient: "Selecciona un cliente",
        delete: "Eliminar",
        confirmDelete: "¿Eliminar este registro?",
        lunch: "Almuerzo (horas)",
        lunchHint: "Se descuentan automáticamente de las horas trabajadas (por defecto 1,5h)",
        closed: "Cerrado",
        paid: "Pagada",
        photos: "Fotos del trabajo (opcional)",
        photosHint: "Se guardarán en la pestaña Fotos, agrupadas por la dirección del cliente",
      },
      reportes: {
        title: "Informes de pago",
        subtitle: "Cálculo automático de horas × valor hora",
        from: "Desde",
        to: "Hasta",
        employee: "Empleado",
        all: "Todos",
        generate: "Generar",
        exportPdf: "Exportar PDF",
        name: "Nombre",
        hourRate: "Valor/hora",
        totalHours: "Horas totales",
        totalPay: "Total a pagar",
        empty: "Sin datos para el período seleccionado",
        grandTotal: "Total general",
        grandTotalNeto: "Total neto a pagar",
        newAdel: "Anotar adelanto",
        adelDate: "Fecha",
        adelAmount: "Importe (€)",
        adelDesc: "Descripción",
        adelantos: "Adelantos",
        adelListTitle: "Adelantos registrados (se descuentan del pago)",
        totalNeto: "Total neto",
      },
      agenda: {
        title: "Agenda",
        subtitle: "Planificación diaria para los empleados",
        add: "Nueva tarea",
        edit: "Editar tarea",
        date: "Fecha",
        employee: "Empleado",
        client: "Cliente",
        start: "Inicio",
        end: "Fin",
        description: "Descripción",
        status: "Estado",
        planned: "Planificado",
        done: "Concluido",
        empty: "No hay tareas programadas",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        multiDay: "Programar en múltiples días",
        selectDates: "Selecciona las fechas",
        datesSelected: "fechas seleccionadas",
        eventsCreated: "tareas creadas",
      },
      fotos: {
        title: "Fotos del trabajo",
        subtitle: "Organizadas por dirección / cliente",
        add: "Subir foto",
        client: "Cliente",
        address: "Dirección",
        date: "Fecha",
        description: "Descripción",
        file: "Archivo",
        selectClient: "Selecciona un cliente",
        empty: "No hay fotos todavía",
        save: "Guardar",
        cancel: "Cancelar",
        view: "Ver",
        delete: "Eliminar",
        photosCount: "fotos",
        noPhotos: "Sin fotos",
        download: "Descargar",
        downloadZip: "Descargar ZIP",
        downloading: "Descargando",
      },
      clientes: {
        title: "Clientes",
        subtitle: "Lista de clientes con dirección y datos",
        add: "Nuevo cliente",
        edit: "Editar cliente",
        name: "Nombre",
        address: "Dirección",
        ciudad: "Ciudad",
        nif: "NIF / CIF",
        phone: "Teléfono",
        email: "Correo",
        notes: "Observaciones",
        empty: "No hay clientes",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
      },
      aprobaciones: {
        title: "Aprobaciones",
        subtitle: "Revisa las horas enviadas por los empleados",
        approve: "Aprobar",
        reject: "Rechazar",
        edit: "Editar horas",
        empty: "No hay horas pendientes",
        filter: "Filtrar",
        all: "Todas",
      },
      funcionarios: {
        title: "Empleados",
        subtitle: "Gestión de empleados y credenciales",
        add: "Nuevo empleado",
        edit: "Editar empleado",
        name: "Nombre",
        email: "Correo",
        password: "Contraseña",
        role: "Rol",
        admin: "Administrador",
        employee: "Empleado",
        hourRate: "Valor/hora (€)",
        phone: "Teléfono",
        position: "Cargo",
        empty: "No hay empleados",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        leaveBlank: "Deja en blanco para no cambiar",
      },
      common: {
        loading: "Cargando...",
        error: "Ocurrió un error",
        success: "Guardado con éxito",
        search: "Buscar...",
        actions: "Acciones",
        confirm: "Confirmar",
        cancel: "Cancelar",
        yes: "Sí",
        no: "No",
      },
      lang: {
        label: "Idioma",
        es: "Español",
        pt: "Português",
      },
      docs: {
        presupuestosTitle: "Presupuestos",
        presupuestosSubtitle: "Crear y gestionar presupuestos para clientes",
        facturasTitle: "Facturas",
        facturasSubtitle: "Crear y gestionar facturas",
        newDoc: "Nuevo",
        editDoc: "Editar",
        number: "Número",
        date: "Fecha",
        client: "Cliente",
        total: "Total",
        status: "Estado",
        actions: "Acciones",
        domicilio: "Domicilio",
        ciudad: "Ciudad",
        nif: "N.I.F",
        comentarios: "Comentarios",
        selectClient: "Selecciona cliente",
        items: "Artículos",
        addItem: "Añadir artículo",
        cod: "Cód.",
        articulo: "Artículo",
        unidad: "Unid.",
        precioUn: "Precio Un.",
        subtotal: "Subtotal",
        iva: "%IVA",
        totalIva: "Total c/IVA",
        formaPago: "Forma Pago",
        observacoes: "Observações",
        descuento: "Descuento %",
        totalDescuento: "Total Descuento",
        baseImponible: "Base Imponible",
        ivaValor: "I.V.A.",
        grandTotal: "TOTAL",
        nota: "Nota",
        save: "Guardar",
        cancel: "Cancelar",
        downloadPdf: "Descargar PDF",
        downloadWord: "Descargar Word",
        view: "Ver",
        delete: "Eliminar",
        empty: "No hay documentos todavía",
        preview: "Vista previa",
        convertToFactura: "Convertir a Factura",
        confirmConvert: "¿Crear una nueva factura con los datos de este presupuesto?",
        confirmDelete: "¿Eliminar este documento? Los números siguientes se reordenarán para no dejar huecos.",
        validez: "Validez de la oferta (días)",
      },
      cierres: {
        title: "Cierre Semanal",
        subtitle: "Cierra períodos de horas aprobadas por empleado para el pago",
        nav: "Cierres",
        newCierre: "Nuevo cierre",
        employee: "Empleado",
        selectEmployee: "Selecciona un empleado",
        from: "Desde",
        to: "Hasta",
        name: "Nombre del cierre",
        preview: "Vista previa",
        closePeriod: "Cerrar período",
        totalHours: "Total horas",
        totalPay: "Total a pagar",
        records: "Registros",
        closedOn: "Cerrado el",
        range: "Período",
        history: "Historial de cierres",
        empty: "No hay cierres todavía",
        confirmClose: "¿Cerrar este período? Las horas quedarán marcadas como pagadas.",
        deleted: "Cierre eliminado",
        confirmDelete: "¿Eliminar este cierre? Las horas vuelven a estado aprobado.",
        noHoursToClose: "No hay horas aprobadas para cerrar",
        reopen: "Reabrir cierre",
        reopened: "Cierre reabierto, horas disponibles para edición",
        confirmReopen: "¿Reabrir este cierre? Las horas volverán a estar disponibles para edición.",
      },
      archivo: {
        title: "Archivo de Ofertas",
        subtitle: "Guarda ofertas y facturas antiguas en PDF",
        add: "Subir PDF",
        uploadHint: "Sube un PDF y extraeremos los datos automáticamente",
        extract: "Extraer datos con IA",
        extracting: "Extrayendo...",
        nombre: "Nombre",
        file: "Archivo PDF",
        fecha: "Fecha",
        total: "Total",
        tipo: "Tipo",
        notas: "Notas",
        cliente: "Cliente",
        domicilio: "Domicilio",
        ciudad: "Ciudad",
        nif: "N.I.F",
        presupuesto: "Presupuesto",
        factura: "Factura",
        view: "Ver PDF",
        download: "Descargar",
        delete: "Eliminar",
        save: "Guardar",
        cancel: "Cancelar",
        empty: "No hay archivos guardados",
        successExtract: "Datos extraídos correctamente",
        clienteExists: "Cliente ya registrado",
      },
      password: {
        change: "Cambiar contraseña",
        current: "Contraseña actual",
        new: "Nueva contraseña",
        confirm: "Confirmar nueva contraseña",
        save: "Guardar",
        changed: "Contraseña actualizada",
        mismatch: "Las contraseñas no coinciden",
      },
      gastos: {
        title: "Gastos",
        subtitle: "Registra y analiza tus gastos mensuales",
        add: "Nuevo gasto",
        edit: "Editar gasto",
        date: "Fecha",
        description: "Descripción",
        category: "Categoría",
        amount: "Importe (€)",
        supplier: "Proveedor",
        payment: "Método de pago",
        notes: "Notas",
        from: "Desde",
        to: "Hasta",
        allCategories: "Todas las categorías",
        total: "Total",
        totalMonth: "Total del período",
        cantidad: "Registros",
        byMonth: "Por mes",
        byCategory: "Por categoría",
        empty: "No hay gastos registrados",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        year: "Año",
      },
      ingresos: {
        title: "Ingresos",
        subtitle: "Pagos recibidos vinculados a presupuestos o facturas",
        add: "Nuevo ingreso",
        edit: "Editar ingreso",
        date: "Fecha",
        amount: "Importe",
        method: "Método de pago",
        document: "Documento vinculado",
        noDoc: "Sin vincular",
        client: "Cliente",
        description: "Descripción",
        totalReceived: "Total recibido",
        entries: "ingresos",
        empty: "No hay ingresos registrados",
        paid: "Pagado",
        pending: "Pendiente",
        statusPagado: "PAGADO",
        statusParcial: "PARCIAL",
        statusPendiente: "PENDIENTE",
        paymentsLabel: "Pagos registrados",
        metodos: {
          transferencia: "Transferencia",
          efectivo: "Efectivo",
          bizum: "Bizum",
          tarjeta: "Tarjeta",
          otro: "Otro",
        },
      },
      finance: {
        title: "Resumen financiero",
        subtitle: "Año {{anio}}",
        mesIngresos: "Ingresos del mes",
        mesGastos: "Gastos del mes",
        mesBeneficio: "Beneficio del mes",
        monthly: "Evolución mensual",
        ingresos: "Ingresos",
        gastos: "Gastos",
      },
    },
  },
  pt: {
    translation: {
      app: {
        name: "Modolo Multiservices S.L.",
        tagline: "Painel de controle",
      },
      nav: {
        dashboard: "Início",
        horas: "Horas",
        reportes: "Relatórios",
        agenda: "Agenda",
        fotos: "Fotos",
        clientes: "Clientes",
        aprobaciones: "Aprovações",
        funcionarios: "Funcionários",
        presupuestos: "Orçamentos",
        facturas: "Faturas",
        cierres: "Fechamentos",
        archivo: "Arquivo",
        gastos: "Despesas",
        ingresos: "Entradas",
        logout: "Sair",
      },
      login: {
        title: "Entrar",
        subtitle: "Acesse o painel da Modolo Multiservices S.L.",
        email: "E-mail",
        password: "Senha",
        submit: "Entrar",
        loading: "Entrando...",
        error: "Credenciais inválidas",
      },
      dashboard: {
        welcome: "Bem-vindo",
        employees: "Funcionários",
        clients: "Clientes",
        pendingHours: "Horas pendentes",
        todayAgenda: "Agenda de hoje",
        photos: "Fotos",
        approvedHours: "Horas aprovadas",
        totalHours: "Total de horas",
        myPending: "Minhas horas pendentes",
        myApproved: "Minhas horas aprovadas",
        myAgenda: "Minha agenda hoje",
        myPhotos: "Minhas fotos",
      },
      horas: {
        title: "Registro de horas",
        subtitle: "Adicione as horas trabalhadas ao final do dia",
        add: "Adicionar horas",
        date: "Data",
        start: "Início",
        end: "Fim",
        total: "Total",
        client: "Cliente",
        notes: "Observações",
        status: "Status",
        actions: "Ações",
        employee: "Funcionário",
        save: "Salvar",
        cancel: "Cancelar",
        pending: "Pendente",
        approved: "Aprovado",
        rejected: "Rejeitado",
        empty: "Nenhum registro de horas",
        selectClient: "Selecione um cliente",
        delete: "Excluir",
        confirmDelete: "Excluir este registro?",
        lunch: "Almoço (horas)",
        lunchHint: "Descontadas automaticamente das horas trabalhadas (padrão 1,5h)",
        closed: "Fechado",
        paid: "Paga",
        photos: "Fotos do trabalho (opcional)",
        photosHint: "Serão salvas na aba Fotos, agrupadas pelo endereço do cliente",
      },
      reportes: {
        title: "Relatórios de pagamento",
        subtitle: "Cálculo automático de horas × valor hora",
        from: "De",
        to: "Até",
        employee: "Funcionário",
        all: "Todos",
        generate: "Gerar",
        exportPdf: "Exportar PDF",
        name: "Nome",
        hourRate: "Valor/hora",
        totalHours: "Total de horas",
        totalPay: "Total a pagar",
        empty: "Sem dados para o período selecionado",
        grandTotal: "Total geral",
        grandTotalNeto: "Total líquido a pagar",
        newAdel: "Anotar adiantamento",
        adelDate: "Data",
        adelAmount: "Valor (€)",
        adelDesc: "Descrição",
        adelantos: "Adiantamentos",
        adelListTitle: "Adiantamentos registrados (descontados do pagamento)",
        totalNeto: "Total líquido",
      },
      agenda: {
        title: "Agenda",
        subtitle: "Planejamento diário para os funcionários",
        add: "Nova tarefa",
        edit: "Editar tarefa",
        date: "Data",
        employee: "Funcionário",
        client: "Cliente",
        start: "Início",
        end: "Fim",
        description: "Descrição",
        status: "Status",
        planned: "Planejado",
        done: "Concluído",
        empty: "Nenhuma tarefa programada",
        save: "Salvar",
        cancel: "Cancelar",
        delete: "Excluir",
        multiDay: "Agendar em múltiplos dias",
        selectDates: "Selecione as datas",
        datesSelected: "datas selecionadas",
        eventsCreated: "tarefas criadas",
      },
      fotos: {
        title: "Fotos do trabalho",
        subtitle: "Organizadas por endereço / cliente",
        add: "Enviar foto",
        client: "Cliente",
        address: "Endereço",
        date: "Data",
        description: "Descrição",
        file: "Arquivo",
        selectClient: "Selecione um cliente",
        empty: "Ainda não há fotos",
        save: "Salvar",
        cancel: "Cancelar",
        view: "Ver",
        delete: "Excluir",
        photosCount: "fotos",
        noPhotos: "Sem fotos",
        download: "Baixar",
        downloadZip: "Baixar ZIP",
        downloading: "Baixando",
      },
      clientes: {
        title: "Clientes",
        subtitle: "Lista de clientes com endereços e dados",
        add: "Novo cliente",
        edit: "Editar cliente",
        name: "Nome",
        address: "Endereço",
        ciudad: "Cidade",
        nif: "NIF / CIF",
        phone: "Telefone",
        email: "E-mail",
        notes: "Observações",
        empty: "Nenhum cliente cadastrado",
        save: "Salvar",
        cancel: "Cancelar",
        delete: "Excluir",
      },
      aprobaciones: {
        title: "Aprovações",
        subtitle: "Revise as horas enviadas pelos funcionários",
        approve: "Aprovar",
        reject: "Rejeitar",
        edit: "Editar horas",
        empty: "Não há horas pendentes",
        filter: "Filtrar",
        all: "Todas",
      },
      funcionarios: {
        title: "Funcionários",
        subtitle: "Gestão de funcionários e credenciais",
        add: "Novo funcionário",
        edit: "Editar funcionário",
        name: "Nome",
        email: "E-mail",
        password: "Senha",
        role: "Função",
        admin: "Administrador",
        employee: "Funcionário",
        hourRate: "Valor/hora (€)",
        phone: "Telefone",
        position: "Cargo",
        empty: "Nenhum funcionário",
        save: "Salvar",
        cancel: "Cancelar",
        delete: "Excluir",
        leaveBlank: "Deixe em branco para manter",
      },
      common: {
        loading: "Carregando...",
        error: "Ocorreu um erro",
        success: "Salvo com sucesso",
        search: "Buscar...",
        actions: "Ações",
        confirm: "Confirmar",
        cancel: "Cancelar",
        yes: "Sim",
        no: "Não",
      },
      lang: {
        label: "Idioma",
        es: "Español",
        pt: "Português",
      },
      docs: {
        presupuestosTitle: "Orçamentos",
        presupuestosSubtitle: "Criar e gerenciar orçamentos para clientes",
        facturasTitle: "Faturas",
        facturasSubtitle: "Criar e gerenciar faturas",
        newDoc: "Novo",
        editDoc: "Editar",
        number: "Número",
        date: "Data",
        client: "Cliente",
        total: "Total",
        status: "Status",
        actions: "Ações",
        domicilio: "Endereço",
        ciudad: "Cidade",
        nif: "N.I.F",
        comentarios: "Comentários",
        selectClient: "Selecione cliente",
        items: "Itens",
        addItem: "Adicionar item",
        cod: "Cód.",
        articulo: "Artigo",
        unidad: "Qtd.",
        precioUn: "Preço Un.",
        subtotal: "Subtotal",
        iva: "%IVA",
        totalIva: "Total c/IVA",
        formaPago: "Forma Pagamento",
        observacoes: "Observações",
        descuento: "Desconto %",
        totalDescuento: "Total Desconto",
        baseImponible: "Base Tributável",
        ivaValor: "I.V.A.",
        grandTotal: "TOTAL",
        nota: "Nota",
        save: "Salvar",
        cancel: "Cancelar",
        downloadPdf: "Baixar PDF",
        downloadWord: "Baixar Word",
        view: "Ver",
        delete: "Excluir",
        empty: "Ainda não há documentos",
        preview: "Pré-visualização",
        convertToFactura: "Converter em Fatura",
        confirmConvert: "Criar uma nova fatura com os dados deste orçamento?",
        confirmDelete: "Excluir este documento? Os números seguintes serão reordenados para não deixar lacunas.",
        validez: "Validade da oferta (dias)",
      },
      cierres: {
        title: "Fechamento Semanal",
        subtitle: "Fecha períodos de horas aprovadas para pagamento",
        nav: "Fechamentos",
        newCierre: "Novo fechamento",
        from: "De",
        to: "Até",
        name: "Nome do fechamento",
        preview: "Pré-visualização",
        closePeriod: "Fechar período",
        totalHours: "Total horas",
        totalPay: "Total a pagar",
        records: "Registros",
        closedOn: "Fechado em",
        range: "Período",
        history: "Histórico de fechamentos",
        empty: "Ainda não há fechamentos",
        confirmClose: "Fechar este período? As horas não poderão ser editadas depois.",
        deleted: "Fechamento excluído",
        confirmDelete: "Excluir este fechamento? As horas voltam para status aprovado.",
        noHoursToClose: "Não há horas aprovadas para fechar nesse período",
      },
      archivo: {
        title: "Arquivo de Ofertas",
        subtitle: "Guarde ofertas e faturas antigas em PDF",
        add: "Enviar PDF",
        uploadHint: "Envie um PDF e extrairemos os dados automaticamente",
        extract: "Extrair dados com IA",
        extracting: "Extraindo...",
        nombre: "Nome",
        file: "Arquivo PDF",
        fecha: "Data",
        total: "Total",
        tipo: "Tipo",
        notas: "Notas",
        cliente: "Cliente",
        domicilio: "Endereço",
        ciudad: "Cidade",
        nif: "N.I.F",
        presupuesto: "Orçamento",
        factura: "Fatura",
        view: "Ver PDF",
        download: "Baixar",
        delete: "Excluir",
        save: "Salvar",
        cancel: "Cancelar",
        empty: "Nenhum arquivo salvo",
        successExtract: "Dados extraídos com sucesso",
        clienteExists: "Cliente já cadastrado",
      },
      password: {
        change: "Alterar senha",
        current: "Senha atual",
        new: "Nova senha",
        confirm: "Confirmar nova senha",
        save: "Salvar",
        changed: "Senha atualizada",
        mismatch: "As senhas não coincidem",
      },
      gastos: {
        title: "Despesas",
        subtitle: "Registre e analise suas despesas mensais",
        add: "Nova despesa",
        edit: "Editar despesa",
        date: "Data",
        description: "Descrição",
        category: "Categoria",
        amount: "Valor (€)",
        supplier: "Fornecedor",
        payment: "Método de pagamento",
        notes: "Notas",
        from: "De",
        to: "Até",
        allCategories: "Todas as categorias",
        total: "Total",
        totalMonth: "Total do período",
        cantidad: "Registros",
        byMonth: "Por mês",
        byCategory: "Por categoria",
        empty: "Nenhuma despesa registrada",
        save: "Salvar",
        cancel: "Cancelar",
        delete: "Excluir",
        year: "Ano",
      },
      ingresos: {
        title: "Entradas",
        subtitle: "Pagamentos recebidos vinculados a orçamentos ou faturas",
        add: "Nova entrada",
        edit: "Editar entrada",
        date: "Data",
        amount: "Valor",
        method: "Método de pagamento",
        document: "Documento vinculado",
        noDoc: "Sem vínculo",
        client: "Cliente",
        description: "Descrição",
        totalReceived: "Total recebido",
        entries: "entradas",
        empty: "Nenhuma entrada registrada",
        paid: "Pago",
        pending: "Pendente",
        statusPagado: "PAGO",
        statusParcial: "PARCIAL",
        statusPendiente: "PENDENTE",
        paymentsLabel: "Pagamentos registrados",
        metodos: {
          transferencia: "Transferência",
          efectivo: "Dinheiro",
          bizum: "Bizum",
          tarjeta: "Cartão",
          otro: "Outro",
        },
      },
      finance: {
        title: "Resumo financeiro",
        subtitle: "Ano {{anio}}",
        mesIngresos: "Entradas do mês",
        mesGastos: "Despesas do mês",
        mesBeneficio: "Lucro do mês",
        monthly: "Evolução mensal",
        ingresos: "Entradas",
        gastos: "Despesas",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    supportedLngs: ["es", "pt"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
